require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-project-euler-problem-216-investigating-the-primality-of-numbers-of-the-form-2-n-2-1.json") })
        }
      }, "path---coding-interview-prep-project-euler-problem-216-investigating-the-primality-of-numbers-of-the-form-2-n-2-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-project-euler-problem-216-investigating-the-primality-of-numbers-of-the-form-2-n-2-1!./.cache/json/coding-interview-prep-project-euler-problem-216-investigating-the-primality-of-numbers-of-the-form-2-n-2-1.json
// module id = 1487
// module chunks = 231608221292675